// Undo of a reversible Gmail change (archive, move back, labels; shared/actionKinds.ts), whether a
// card or the inbox started it. While its work still waits, cancelling it is the undo and nothing
// reaches Gmail. Once it ran (or the executor already holds it: the cancel answers 409), the undo
// is the reverse change, one more approval the gateway binds, verifies and runs like the first.
import { isApiError } from "./api";

export type ReversibleUndo = "cancelled" | "reversed";

export async function undoReversible(steps: {
  cancel: () => Promise<unknown>;
  reverse: () => Promise<unknown>;
}): Promise<ReversibleUndo> {
  try {
    await steps.cancel();
    return "cancelled";
  } catch (error) {
    if (!isApiError(error) || error.status !== 409) throw error;
  }
  await steps.reverse();
  return "reversed";
}
